/*
 * @Author: xuesong
 * @Date: 2021-05-17 11:06:20
 * @LastEditTime: 2021-05-25 15:43:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/common/table.js
 */
export default {
  data() {
    return {
      // 药品表格
      drugTableListConfig: [
        // {
        //   label: '序号',
        //   align: 'center',
        //   fixed: 'left',
        //   prop: 'id',
        //   size: 'mini',
        //   width: '50px',
        //   // render: (h, scope) => {
        //   //   return <span slot="reference">{scope.$index * 1 + 1}</span>
        //   // },
        // },
        {
          label: '一级类目',
          align: 'center',
          prop: 'firstCategroyName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '二级类目',
          align: 'center',
          prop: 'secondCategoryName',
          size: 'mini',
          showOverflowTooltip: true
        },

        {
          label: '药品名称',
          align: 'center',
          prop: 'name',
          size: 'mini',
        },
        {
          label: '通用名称',
          align: 'center',
          prop: "currencyName",
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '商品名称',
          align: 'center',
          prop: 'shopName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '品牌名',
          align: 'center',
          prop: 'brandName',
          size: 'mini',
        },
        {
          label: '英文名称',
          align: 'center',
          prop: 'english',
          size: 'mini',
        },
        {
          label: '批准文号',
          align: 'center',
          prop: 'approvalNumber',
          size: 'mini',
        },
        {
          label: '药品编码',
          align: 'center',
          prop: 'code',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '生产企业',
          align: 'center',
          prop: 'venderName',
          size: 'mini'
        },
        {
          label: '规格',
          align: 'center',
          prop: 'packageSpName',
          size: 'mini',
          showOverflowTooltip: true


        },
        {
          label: '剂型',
          align: 'center',
          prop: 'dosageForm',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '操作',
          align: 'center',
          fixed: "right",
          width: '180px',
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          render: (h, scope) => {
            return h('div', scope.row.rwsData?[h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  //   attrs: {
                  //     disabled: scope.row.paymentState != 1 ? true : false,
                  //   },
                  on: {
                    click: () => {
                      this.editRowData(scope.row)
                    },
                  },
                },
                '编辑'
              )]:[
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.showRowData(scope.row, 'details')
                    },
                  },
                },
                '查看'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  //   attrs: {
                  //     disabled: scope.row.paymentState != 1 ? true : false,
                  //   },
                  on: {
                    click: () => {
                      this.editRowData(scope.row)
                    },
                  },
                },
                '编辑'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.disableRowData(scope.row)
                    },
                  },
                },
                scope.row.isEnable==0 ? '停用':'启用'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.deleteRowData(scope.row)
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ],
      // 治疗表格
      treatmentTableListConfig: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          prop: 'date',
          size: 'mini',
          width: '50px',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },



        {
          label: '治疗类别',
          align: 'center',
          prop: 'patientName',
          size: 'mini',
        },
        {
          label: '操作编码',
          align: 'center',
          prop: "doctorTeamName",
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '操作名称',
          align: 'center',
          prop: 'platformName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '操作部位名称',
          align: 'center',
          prop: 'amountOriginal',
          size: 'mini',
        },
        {
          label: '介入物名称',
          align: 'center',
          prop: 'discount',
          size: 'mini',
        },
        {
          label: '操作方法描述',
          align: 'center',
          prop: 'payAmount',
          size: 'mini',
        },
        {
          label: '操作次数',
          align: 'center',
          prop: 'createTime',
          size: 'mini',
          showOverflowTooltip: true
        },


        {
          label: '操作',
          align: 'center',
          fixed: "right",
          width: '150px',
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.showRowData(scope, 'details')
                    },
                  },
                },
                '查看'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  //   attrs: {
                  //     disabled: scope.row.paymentState != 1 ? true : false,
                  //   },
                  on: {
                    click: () => {
                      this.editRowData(scope.row)
                    },
                  },
                },
                '编辑'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.disableRowData(scope.row)
                    },
                  },
                },
                '停用'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.deleteRowData(scope.row)
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ],
    }
  }
}